var _defs, _g, _mask, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadPageFormMobileBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "320px",
    height: "502px",
    viewBox: "0 0 320 502",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8DFF9C67-3DDB-434E-81D1-4FE1823BC6CF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "-1.11022302e-15 0 320 0 320 296 -1.11022302e-15 296"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "-1.11022302e-15 0 320 0 320 502 -1.11022302e-15 502"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05E2\\u05DE\\u05D5\\u05D3-\\u05DC\\u05D9\\u05D3\\u05D9\\u05DD-\\u05DE\\u05D5\\u05D1\\u05D9\\u05D9\\u05DC",
    transform: "translate(0.000000, -619.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(0.000000, 619.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F3F4F7",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2E2D79",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_472",
    opacity: 0.848795573,
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-330.335281, -247.612297)",
    id: "Group_55",
    opacity: 0.716634115
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1837",
    fill: "#9C9C9C",
    fillRule: "nonzero",
    opacity: 0.483816964
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1838",
    opacity: 0.504101563
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path_154",
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "translate(462.851524, 507.283862) rotate(-62.157000) translate(-462.851524, -507.283862) ",
    points: "33.6133401 233.783862 835.696887 568.783481 892.089708 780.783862 90.0062624 445.783941"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_156",
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "translate(447.213996, 644.401374) rotate(-62.153378) translate(-447.213996, -644.401374) ",
    points: "284.095858 571.489367 607.466739 706.547981 610.332133 717.313381 286.961253 582.254767"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_157",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "translate(591.279396, 499.056131) rotate(-62.115000) translate(-591.279396, -499.056131) ",
    points: "429.134445 430.113006 752.707356 565.307759 753.424348 567.999256 429.851437 432.804503"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_158",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "translate(327.222990, 525.642519) rotate(-62.153378) translate(-327.222990, -525.642519) ",
    points: "-9.7881829 333.601432 633.557493 602.320431 664.234164 717.683605 20.8902463 448.964204"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadPageFormMobileBackground);
export default __webpack_public_path__ + "static/media/lead_page_form_mobile_background.cbcc6debcaf5810c255da52a73a17625.svg";
export { ForwardRef as ReactComponent };